import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import styled from 'styled-components/macro';

import { grid, distances } from '../../../styles/constants';
import { Transaction } from '../../../types/checkout';
import { P } from '../../../components/Typography';
import { Button, ButtonGroup } from '../../../components/Buttons';
import { formatMoney } from '../../../helpers/formatters';
import { getCapturableAmount } from '../../transactionHelpers';

type VoidFormProps = {
    transaction: Transaction;
    voidTransaction: (accountId: string, transaction: Transaction) => Promise<Transaction | undefined>;
    accountId: string;
    isLoading: boolean;
    showSuccessMessage: () => void;
};

const VoidForm = ({
    transaction,
    voidTransaction,
    accountId,
    isLoading,
    showSuccessMessage,
}: VoidFormProps) => {
    const { t, i18n } = useTranslation();


    const capturableAmount = getCapturableAmount(transaction);
    const amount_with_currency = formatMoney(i18n.language, capturableAmount, transaction.currency);
    return (
        <Wrapper>
            <VoidTextWrapper>
                <VoidP>{t('payments.voidTransaction.form.explanation')}</VoidP>
                <VoidP>
                    <Trans
                        i18nKey="payments.voidTransaction.form.consequence"
                        values={{
                            transaction_id: transaction.merchant_reference || transaction.id,
                            amount_with_currency,
                        }}
                    >
                            Text
                        <strong>{{ transaction_id: transaction.merchant_reference || transaction.id }}</strong>
                    </Trans>
                </VoidP>
            </VoidTextWrapper>
            <ButtonGroup>
                <VoidButton
                    disabled={isLoading}
                    onClick={() => {
                        voidTransaction(accountId, transaction).then(result => {
                            if (result) {
                                showSuccessMessage();
                            }
                        });
                    }}
                >
                    {t('payments.voidTransaction.form.void_button')}
                </VoidButton>
            </ButtonGroup>
        </Wrapper>
    );
};

export default VoidForm;

const Wrapper = styled.div`
    position: relative;
    width: ${grid.spans.span6};
`;

const VoidTextWrapper = styled.div`
    margin-top: ${distances.small};
    margin-bottom: ${distances.small};
`;

const VoidP = styled(P)`
    margin-bottom: ${distances.small};
    line-height: ${distances.small};
`;

const VoidButton = styled(Button)`
    min-width: 220px;
`;
